import { FC } from 'react'
import { RenderFieldsErrorsProps } from '../Forms.d'

const RenderFieldsErrors: FC<RenderFieldsErrorsProps> = ({
    errMsg,
    errorFields = {},
}) => {
    return (
        <>
            {typeof errMsg === 'string' ? (
                errMsg
            ) : (
                <>
                    {Object.keys(errorFields).length > 0 ? (
                        (() => {
                            return (
                                <ul>
                                    {Object.keys(errorFields).map(
                                        (k, index: number) => {
                                            return (
                                                <li key={index}>
                                                    {typeof k !== 'number'
                                                        ? errorFields[k]
                                                        : k}
                                                </li>
                                            )
                                        }
                                    )}
                                </ul>
                            )
                        })()
                    ) : (
                        <></>
                    )}
                </>
            )}
        </>
    )
}

export default RenderFieldsErrors
